import { configureStore } from '@reduxjs/toolkit'

import rootReducer, { RootState as RootStateFromReducer } from './reducers/rootReducer'

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false }),
})

export default store
export type RootState = RootStateFromReducer
export type AppDispatch = typeof store.dispatch
